import { service } from "../../../../../../lib/itn-ui-kit/services/service-container.js";
import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import Template from "./template.jsx";

export default class ClientDetailDocumentsAllDocsRoute extends BaseRoute {
  @service('repositories/document-repository') documentRepository;
  @service('repositories/document-validate-repository') documentValidateRepository;
  @service('repositories/provider-client-status-repository') providerClientStatusRepository;
  @service('repositories/case-repository') caseRepository;
 
  element = <Template />;
 
  async loader({ params, request }) {
    const { id } = params;
   
    const _case = await this.caseRepository.findRecord(id);
    const documentsOpts = await this.documentRepository.getOptions();

    const url = new URL(request.url);
    const offset = parseInt(url.searchParams.get('offset') || '0');
    const limit = parseInt(url.searchParams.get('limit') || '10');
    
    const documents = await this.documentRepository.query({
      case: id,
      limit,
      offset
    });

    const documentsCount = await this.documentRepository.getTotalCount({ case: id });
    const providersClient = await this.providerClientStatusRepository.query({ case: id });
    const providers = providersClient.map((client) => client?.provider);
    const documentValidation = await this.documentValidateRepository.get();
    
    const deleteDocument = async (docId) => await this.documentRepository.delete(docId);
    const patchDocument = async (docId, body) => await this.documentRepository.patch(docId, body);

    return {
      _case,
      documents,
      documentsCount,
      documentsOpts,
      documentValidation,
      providers,
      deleteDocument,
      patchDocument,
    };
  }
}
